import { render, staticRenderFns } from "./ProductionContainer.vue?vue&type=template&id=279a82ee&scoped=true"
import script from "./ProductionContainer.vue?vue&type=script&lang=js"
export * from "./ProductionContainer.vue?vue&type=script&lang=js"
import style0 from "./ProductionContainer.vue?vue&type=style&index=0&id=279a82ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279a82ee",
  null
  
)

export default component.exports